<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Job #</h4>
                  <v-select
                    :options="jobs"
                    item-text="label"
                    item-value="value"
                    v-model="searchJobNum"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Employee</h4>
                  <v-select
                    :options="employee"
                    label="name"
                    v-model="searchEmployee"
                    :class="{
                      'is-invalid ddl-is-invalid':
                        createReport_errors.employeeError,
                    }"
                  ></v-select>
                  <div
                    v-if="createReport_errors.employeeError"
                    class="invalid-feedback"
                  >
                    <span>{{ createReport_errors.employeeMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">Start Date</h4>
                <date-picker
                  v-model="searchStartDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
              <div class="col-lg-3">
                <h4 class="card-title">End Date</h4>
                <date-picker
                  v-model="searchEndDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>
            <!-- end row -->
            <div class="row mt-3 float-right">
              <div class="col-12">
                <b-button
                  id="btn_search"
                  variant="primary"
                  v-on:click="generateReport()"
                  >Generate</b-button
                >
              </div>
            </div>
            <!-- en row -->
          </div>
        </div>
        <!-- end card -->

        <!-- Table -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Documents</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="row justify-content-start">
              <!-- Approved Toggle -->
              <div class="col-sm-1 col-md-1 mr-2">
                <div class="col-1 pl-0">
                  <div class="form-group">
                    <switches
                      text-enabled="Unreviewed"
                      text-disabled="All Docs"
                      v-model="showUnreviewedDocs"
                      type-bold="false"
                      color="primary"
                      class="mb-0"
                    ></switches>
                  </div>
                </div>
              </div>
              <!-- End Approved Toggle -->
              <!-- Bulk Download Button (Conditional based on if docs are .selected) -->
              <div
                class="pb-4 col-sm-3 col-md-3"
                v-if="
                  (!showUnreviewedDocs &&
                    tableData.some((o) => o.selected == true)) ||
                  (showUnreviewedDocs &&
                    filteredTableData.some((o) => o.selected == true))
                "
              >
                <small>Download Selected</small>
                <br />
                <b-button
                  variant="primary"
                  class="btn btn-sm btn-primary"
                  @click="onBulkDownloadFile()"
                >
                  <span v-if="!this.loading" class="px-3">Download</span>
                  <div v-if="this.loading" class="px-4">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Loading...</span>
                  </div>
                </b-button>
              </div>
              <!-- Bulk Download Button End -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="
                  !showUnreviewedDocs
                    ? tableData
                    : showUnreviewedDocs
                    ? filteredTableData
                    : []
                "
                :fields="fields"
                ref="documentsTable"
                style="text-align: center"
                primary-key="id"
              >
                <template v-slot:cell(selected)="data">
                  <b-form-checkbox v-model="data.item.selected">
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(jobNum)="data">
                  <router-link
                    :to="{
                      path:
                        '/production/jobs/jobDetails/' +
                        getJobNumFromString(data.item.jobNum),
                    }"
                  >
                    {{ data.item.jobNum }}
                  </router-link>
                </template>
                <template v-slot:cell(edit)="data">
                  <div>
                    <b-dropdown variant="primary" size="sm">
                      <template v-slot:button-content>
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        @click="
                          onDownloadFile(data.item.fileName, data.item.jobNum)
                        "
                      >
                        <i class="bx bx-cloud-download mr-2 tableIcons"></i>
                        Download
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          onDeleteFile(
                            data.item.fileName,
                            data.item.id,
                            data.item.fileSize,
                            data.item.jobNum
                          )
                        "
                      >
                        <i class="bx bx-trash mr-2 tableIcons"></i>
                        Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
                <template v-slot:cell(reviewed)="data">
                  <div
                    :id="`docReviewed-${data.item.id}`"
                    style="display: inline-block"
                  >
                    <b-form-checkbox v-model="data.item.reviewed" @change="(newValue) => reviewDocument(newValue, data.item.id)">
                    </b-form-checkbox>
                  </div>
                  <b-tooltip
                    :target="`docReviewed-${data.item.id}`"
                    triggers="hover"
                    v-if="data.item.reviewed && data.item.reviewedBy"
                  >
                    {{
                      `Approved by ${
                        data.item.reviewedBy.name
                      } on ${data.item.reviewedTime
                        .toString()
                        .substring(0, 15)} at ${data.item.reviewedTime
                        .toString()
                        .substring(16, 21)}`
                    }}
                  </b-tooltip>
                </template>
                <template v-slot:cell(file)="data">
                  <div class="row text-left">
                    <div clas="col-3">
                      <div class="avatar-sm">
                        <span
                          class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                      </div>
                    </div>
                    <div class="col-9">
                      <h5 class="font-size-14 mb-1">
                        <a
                          @click="
                            onDownloadFile(data.item.fileName, data.item.jobNum)
                          "
                          href="javascript: void(0);"
                          class="text-dark"
                          >{{ formattedFileName(data.item.fileName) }}</a
                        >
                      </h5>
                      <small
                        >Size : {{ sizeInBytes(data.item.fileSize) }}</small
                      >
                    </div>
                  </div>
                </template>
                <template v-slot:cell(UploadedBy)="data">
                  <a class="badge badge-primary font-size-15 mr-2 no-pointer">
                    {{ data.item.uploadedBy.name }}
                  </a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';
import DatePicker from 'vue2-datepicker';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
import Swal from 'sweetalert2';
import axios from 'axios';
import Switches from 'vue-switches';
import JSZip from 'jszip';
import saveAs from 'file-saver';

import firebase from 'firebase';
import { getEmployees, getJobs } from '../helper/dbHelpers.js';
import { bytesToSize } from '../helper/helpers.js';
import {
  searchFiles,
  downloadFile,
  deleteFile,
} from '../helper/storageHelpers.js';

export default {
  page: {
    title: 'Document Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Switches,
  },
  data() {
    return {
      title: 'Documents Report',
      name: 'documentsReport',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'documents report',
          href: '/production/reports/documentsReport',
          active: true,
        },
      ],
      routes: routes,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'Date',
      sortDesc: false,
      employee: [],
      jobs: [],
      searchEmployee: null,
      searchJobNum: [],
      searchStartDate: null,
      searchEndDate: null,
      tableData: [],
      fields: [
        { key: 'selected', sortable: true },
        { key: 'Edit', sortable: false },
        { key: 'reviewed', sortable: true },
        { key: 'date', sortable: true },
        { key: 'jobNum', label: 'Job', sortable: true },
        { key: 'File', label: 'File', sortable: true },
        { key: 'UploadedBy', label: 'Uploaded By', sortable: true },
      ],
      createReport_errors: {
        employeeError: null,
        employeeMessage: null,
      },
      queryIDs: null,
      showUnreviewedDocs: false,
      loading: false,
      currentUser: this.$store.state.custom.currentUserData,
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    filteredTableData() {
      return this.tableData.filter((doc) => doc.reviewed === false);
    },
    reviewedDocsFiltered() {
      return this.filteredTableData.map((data) => ({
        id: data.id,
        reviewed: data.reviewed,
      }));
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if (currentUserDataCopy.tablePageLengths.perPage_documents) {
            oldCurrentUserPerPage =
              currentUserDataCopy.tablePageLengths.perPage_documents;
          }
          currentUserDataCopy.tablePageLengths['perPage_documents'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_documents: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firebase
              .firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },

    async tableData(newItems) {
      let array = [...newItems];
      let jobsMap = {};
      if (array.length > 0 && array.length !== undefined) {
        this.specificJob = [];

        for (let index = 0; index < array.length; index++) {
          let item = array[index];
          // limit db reads so it only gets unique Jobs by comparing to jobsMap
          if (jobsMap[item.jobNum] === undefined) {
            let query = firebase
              .firestore()
              .collection('jobs')
              .where('org', '==', sessionStorage.getItem('org'))
              .where('jobNum', '==', Number(item.jobNum));
            try {
              await query
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    // add job and job description to map
                    jobsMap[item.jobNum] = doc.data().description;
                    // update tabledata
                    let timeItem = array[index];
                    timeItem.jobNum =
                      timeItem.jobNum + ` - ${jobsMap[item.jobNum]}`;
                  });
                })
                .catch((err) => {
                  console.log(err);
                  Vue.$toast.open({
                    message: `Error getting specific job from database.`,
                    duration: 4000,
                    position: 'top-right',
                    dismissible: true,
                    type: 'error',
                  });
                });
            } catch (err) {
              console.log(err);
              Vue.$toast.open({
                message: `Error adding job descriptions to the time table`,
                duration: 4000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            }
          } else {
            // job info for this table data item has already been pulled from db so find it in map and use it
            // update tabledata
            let jobDescription = jobsMap[item.jobNum]
              ? jobsMap[item.jobNum]
              : 'no';
            let timeItem = array[index];
            timeItem.jobNum = timeItem.jobNum + ` - ${jobDescription}`;
          }
        }
      }
    },
  },
  methods: {
    getInitialJobs() {
      this.jobs = [];
      getJobs()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const jobData = doc.data();
            this.jobs.push({
              value: jobData.jobNum,
              label: `${jobData.jobNum} - ${jobData.description}`,
            });
          });
        })
        .catch((err) => {
          console.log(`Error getting job numbers from customer.`);
          console.log(err);
        });
    },
    getInitialEmployees() {
      getEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.employee.push({
              name: doc.data().displayName,
              id: doc.data().auth,
            });
          });
        })
        .catch(() => {
          console.log(`Error getting Employees...`);
        });
    },
    async generateReport() {
      this.tableData = await searchFiles(
        this.searchJobNum.value,
        this.searchEmployee != null ? this.searchEmployee.id : null,
        this.searchStartDate,
        this.searchEndDate,
        this.queryIDs
      );
    },
    async initialReportGeneration() {
      this.tableData = await searchFiles(null, null, null, null, this.queryIDs);
    },
    sizeInBytes: function (fileSize) {
      return bytesToSize(fileSize);
    },
    formattedFileName: function (fileName) {
      return fileName.substring(fileName.indexOf('-') + 1);
    },
    onDeleteFile: function (fileName, id, fileSize, jobID) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This file will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          let success = await deleteFile(
            fileName,
            jobID.split(' - ')[0],
            false,
            id,
            fileSize
          );
          if (success) {
            //remove the file from the lsit.
            let index = this.tableData.findIndex((o) => o.id == id);
            this.tableData.splice(index, 1);
            Vue.$toast.open({
              message: 'Document successfully deleted',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          } else {
            Swal.fire('Error!', 'Error deleting file.', 'error');
          }
        }
      });
    },
    onDownloadFile: async function (fileName, jobID) {
      let downloadURL = await downloadFile(fileName, jobID.split(' - ')[0]);

      axios
        .get(downloadURL, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.formattedFileName(fileName);
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },

    onBulkDownloadFile: async function () {
      this.loading = true;
      try {
        let jszip = new JSZip();
        const currentDate = new Date();
        // bulk download for tableData
        if (!this.showUnreviewedDocs) {
          // filter out .selected items
          let selectedFiles = this.tableData.filter((o) => o.selected);
          // loop through selectedFiles
          for (let index = 0; index < selectedFiles.length; index++) {
            let downloadURL;
            try {
              // get download URL for each file
              downloadURL = await downloadFile(
                selectedFiles[index].fileName,
                selectedFiles[index].jobNum.split(' - ')[0]
              );
            } catch {
              (err) => {
                console.log(err);
                Vue.$toast.open({
                  message: 'Error downloading file URL.',
                  type: 'error',
                  duration: 4000,
                  position: 'top-right',
                });
              };
            }
            // add file name and call to download file into the jszip object
            jszip.file(
              selectedFiles[index].fileName,
              this.downloadUrlAsPromise(downloadURL) // This gets download
            );
            // Once at last file create zip file and save/download jszip object for user
            if (index == selectedFiles.length - 1) {
              jszip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(
                  content,
                  `KaliDocuments-${currentDate.toDateString()}.zip`
                );
              });
            }
          }
          this.loading = false;
        }

        // bulk download for filteredTableData
        if (this.showUnreviewedDocs) {
          // filter out .selected items
          let selectedFiles = this.filteredTableData.filter((o) => o.selected);
          // loop through selectedFiles
          for (let index = 0; index < selectedFiles.length; index++) {
            let downloadURL;
            try {
              // get download URL for each file
              downloadURL = await downloadFile(
                selectedFiles[index].fileName,
                selectedFiles[index].jobNum
              );
            } catch {
              (err) => {
                this.loading = false;
                console.log(err);
                Vue.$toast.open({
                  message: 'Error downloading file URL.',
                  type: 'error',
                  duration: 4000,
                  position: 'top-right',
                });
              };
            }
            // add file name and call to download file into the jszip object
            jszip.file(
              selectedFiles[index].fileName,
              this.downloadUrlAsPromise(downloadURL) // This gets download
            );
            // Once at last file create zip file and save/download jszip object for user
            if (index == selectedFiles.length - 1) {
              jszip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(
                  content,
                  `KaliDocuments-${currentDate.toDateString()}.zip`
                );
              });
            }
          }
          this.loading = false;
        }
      } catch {
        (err) => {
          this.loading = false;
          console.log(err);
          Vue.$toast.open({
            message: 'Error downloading zip file.',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        };
      }
    },
    downloadUrlAsPromise: function (url) {
      try {
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'arraybuffer';
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                resolve(xhr.response);
              } else {
                reject(new Error('Error for ' + url + ': ' + xhr.status));
              }
            }
          };
          xhr.send();
        });
      } catch {
        (err) => {
          this.loading = false;
          console.log(err);
          Vue.$toast.open({
            message: 'Error downloading file(s) for the .zip.',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        };
      }
    },

    reviewDocument: async function (value, id) {
      try {
        let page = firebase.firestore().collection('jobDocuments').doc(id);

        let user = JSON.parse(sessionStorage.authUser);
        let reviewedTime = Date.now();

        let index = this.tableData.findIndex((data) => data.id === id);
        let newData = JSON.parse(JSON.stringify(this.tableData[index]));
        newData.reviewed = value;
        newData.reviewedTime = value ? Date(reviewedTime) : null;
        newData.reviewedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;

        await page
          .update({
            reviewed: newData.reviewed,
            reviewedTime: newData.reviewedTime,
            reviewedBy: newData.reviewedBy,
          })
          .then(() => {
            this.tableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Document reviewed successfully'
                : 'Document unreviewed successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing document reviewal status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the documents reviewal status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered', 'error');
      }
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_documents) {
          this.perPage = this.currentUser.tablePageLengths.perPage_documents;
        }
      }
    },
    getJobNumFromString(timeData) {
      if (typeof timeData === 'string') {
        const jobString = timeData;
        let wordArray = jobString.split(' ');
        return wordArray[0];
      }
    },
  },
  created: function () {
    this.getInitialEmployees();
    this.getInitialJobs();
    this.setTableSettings();

    //get the query strings from the route, if there are any.
    if (
      this.$route.query != undefined &&
      this.$route.query.query != undefined
    ) {
      //parse the files ids here.
      this.queryIDs = this.$route.query.query.files.split(',');

      //generate the report with the selected ids.
      this.initialReportGeneration();
    }
  },
};
</script>
